import { render, staticRenderFns } from "./tableHistoricoVendas.vue?vue&type=template&id=36638dde&scoped=true&"
import script from "./tableHistoricoVendas.vue?vue&type=script&lang=js&"
export * from "./tableHistoricoVendas.vue?vue&type=script&lang=js&"
import style0 from "./tableHistoricoVendas.vue?vue&type=style&index=0&id=36638dde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36638dde",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSimpleTable,VSkeletonLoader})
